"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, resources*/
(function () {
  Kobo.Utilities.assignToNamespace('Kobo.Enums.ProductType', Kobo.Enum.define({
    Unknown: ['Unknown', 0],
    Book: ['Book', 1],
    GiftCard: ['GiftCard', 4],
    StoreCredit: ['StoreCredit', 7],
    Ereader: ['Ereader', 8],
    KwlAuthorMerch: ['KwlAuthorMerch', 9],
    KoboLoveMembership: ['KoboLoveMembership', 10],
    BookSubscription: ['BookSubscription', 11],
    Audiobook: ['Audiobook', 12],
    AudiobookSubscription: ['AudiobookSubscription', 13],
    AudiobookCreditPack: ['AudiobookCreditPack', 14]
  }));

  var ProductTypeExtensions = /*#__PURE__*/function () {
    function ProductTypeExtensions() {
      _classCallCheck(this, ProductTypeExtensions);
    }

    _createClass(ProductTypeExtensions, null, [{
      key: "mapToResourceString",
      value: function mapToResourceString(productType) {
        var _map;

        var ProductType = Kobo.Enums.ProductType,
            resourceStrings = resources.getString('productType');
        var map = (_map = {}, _defineProperty(_map, ProductType.Book, resourceStrings.ebook), _defineProperty(_map, ProductType.Audiobook, resourceStrings.audiobook), _map);
        return map[productType] || '';
      }
    }]);

    return ProductTypeExtensions;
  }();

  Kobo.Utilities.assignToNamespace('Kobo.Enums.ProductType.Extensions', ProductTypeExtensions);
})();